import { render, staticRenderFns } from "./Playlist.vue?vue&type=template&id=97af2124&scoped=true"
import script from "./Playlist.vue?vue&type=script&lang=js"
export * from "./Playlist.vue?vue&type=script&lang=js"
import style0 from "./Playlist.vue?vue&type=style&index=0&id=97af2124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97af2124",
  null
  
)

export default component.exports